export const formatWhatsAppNumber = (phoneStr) => {
  if (!phoneStr) return "Desconhecido";

  // 1. Trata o ID de Privacidade do WhatsApp (@lid)
  if (phoneStr.includes("@lid")) {
    const id = phoneStr.replace("@lid", "");
    return `ID Oculto (${id})`;
  }

  // 2. Limpa os sufixos do WhatsApp
  let cleanPhone = phoneStr
    .replace(/@s\.whatsapp\.net/g, "")
    .replace(/@c\.us/g, "");

  // Extrai APENAS os números
  let digits = cleanPhone.replace(/\D/g, "");

  // 3. Normaliza: Se tiver o 55 do Brasil na frente, a gente tira temporariamente
  // para tratar todos os números de forma igual (DDD + 8 ou 9 dígitos)
  if (
    digits.startsWith("55") &&
    (digits.length === 12 || digits.length === 13)
  ) {
    digits = digits.substring(2);
  }

  // 4. Formata Padrão Brasil (DDD + 8 ou 9 dígitos)
  if (digits.length === 10) {
    // Formato antigo 8 dígitos (ex: 8892337408 -> (88) 9233-7408)
    const ddd = digits.slice(0, 2);
    const p1 = digits.slice(2, 6);
    const p2 = digits.slice(6, 10);
    return `(${ddd}) ${p1}-${p2}`;
  } else if (digits.length === 11) {
    // Formato novo 9 dígitos (ex: 88992337408 -> (88) 99233-7408)
    const ddd = digits.slice(0, 2);
    const p1 = digits.slice(2, 7);
    const p2 = digits.slice(7, 11);
    return `(${ddd}) ${p1}-${p2}`;
  }

  // Se for internacional ou um número esquisito, devolve só o número limpo
  return digits || cleanPhone;
};

export const formatDuration = (totalSeconds) => {
  if (
    totalSeconds === null ||
    totalSeconds === undefined ||
    isNaN(totalSeconds)
  ) {
    return "-";
  }

  if (totalSeconds === 0) {
    return "-";
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const parts = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }

  if (seconds > 0 && hours === 0) {
    parts.push(`${seconds}s`);
  }

  return parts.length > 0 ? parts.join(" ") : "-";
};

export const formatCNPJ = (cnpj) => {
  if (!cnpj) return "";

  // Remove tudo que não for número
  const numericCnpj = String(cnpj).replace(/\D/g, "");

  // Se não tiver exatamente 14 números, retorna do jeito que veio para não quebrar a tela
  if (numericCnpj.length !== 14) return cnpj;

  // Aplica a máscara: 00.000.000/0000-00
  return numericCnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    "$1.$2.$3/$4-$5",
  );
};
